import { createAction } from 'redux-actions';

const OPEN_PUBLIC_SEARCH_MODAL = 'OPEN_PUBLIC_SEARCH_MODAL';
const HIDE_PUBLIC_SEARCH_MODAL = 'HIDE_PUBLIC_SEARCH_MODAL';

export const openPublicSearchModal = createAction(OPEN_PUBLIC_SEARCH_MODAL);
export const closePublicSearchModal = createAction(HIDE_PUBLIC_SEARCH_MODAL);
